var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#key';
                    var viewUrl = 'svg/icons.svg#view-key';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 16 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };